<template>
  <div style="height: 100%;width:100%;background:#044578">
    <el-row ></el-row>
    <el-row style="margin-top:30px;margin-bottom:30px;height:45px;line-height:45px;color:#ffffff">
      <el-col :span="1" :offset="1" @click.native="back()" style="font-size: 40px;cursor:pointer">  <i class="el-icon-arrow-left"></i></el-col>
      <el-col :span="16" :offset="1" style="font-size: 26px;
          height: auto;
          text-align: left;
          color: #ffffff;
          font-weight: bold;"
      >请选择您要展示的项目
      </el-col>
      <el-col v-if="customer.dealerid" :span="4"
        style="font-size: 26px;
              height:45px;line-height:45px;
              text-align: right;
              color: #ffffff;
              font-weight: bold;
              cursor:pointer"
              @click.native="daping()"
              >
        <span style="vertical-align: middle;">大屏报表</span>
      </el-col>
    </el-row>
    <el-row v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"  element-loading-background="#044578" style="width:100%;height:calc(100% - 110px);  display: flex;
        flex-wrap: wrap; justify-content:center;">
      <el-row style="">
        <el-col :span="6" :offset="1">
          <el-input placeholder="请输入项目名称" v-model="projectname" @change="filterProject()">
            <template template slot="prepend">查找项目</template>
          </el-input>
        </el-col>
        <el-col :span="6">
           <el-select v-model="online" clearable @change="filterProject"  placeholder="在线状态">
             <el-option label="全部状态" :value="''">   </el-option>
    <el-option label="在线" :value="1">   </el-option>
       <el-option label="离线" :value="0">   </el-option>
  </el-select>
        </el-col>
         <el-col :span="6" style="text-align:left">
            <el-select v-model="city" clearable placeholder="请选择城市"  @change="filterProject">
              <el-option label="全部城市" :value="''">   </el-option>
    <el-option
      v-for="item in citys"
      :key="item"
      :label="item"
      :value="item">
    </el-option>
  </el-select>
        </el-col>
      </el-row>
      <el-col :span="22" :offset="1" style="overflow-y:auto;height: calc(100% - 45px);">
        <el-collapse v-if="customer.dealerid&&customer.username=='menred'" style="border-top: 1px solid #999999 !important;margin-top:20px" v-model="activeNames">
           <el-collapse-item style="background: inherit;" :title="'自有项目，项目总数：'+filterProjectList.filter(p=>{return !!!p.dealerid}).length" name="">
   <el-col v-for="p in filterProjectList.filter(p=>{return !!!p.dealerid})" :key="p.innerid" @click.native="select(p)" style="margin-left:20px; width: 305px;cursor:pointer;border: 1px solid #aaaaaa;color:#666666;border-radius: 20px;font-size:16px; background:#FFFFFF; margin-top:20px; padding: 10px 0;">
          <el-row></el-row>
          <el-row style="margin-top:10px;text-align:left;min-height:124px">
            <el-col :span="11" style="text-align:center">
              <div class="pic" :style="{'background-image':'url(http://resource.mibee.cn/resource/'+(p.saaspic||'dba06208-8bcd-4bfa-9478-18ebcda63264')+')'}" style="width: 100px;height: 100px;background-image: ;background-size: 100% 100%;border-radius: 20px;margin-left: 20px;margin-top: 9px;margin-bottom:5px">
              </div>
            <span style="font-size:12px;color:#999999;">{{p.protocolid===227?'AIO':'CCH'}}系统</span><img v-if="p['4gstatus']" style="margin-left:10px;height:12px;width:12px" :src='"../../static/images/icon/4g-"+(JSON.parse(p["4gstatus"]).rssiLevel||0)+".png"'/>
            </el-col>
            <el-col :span="13" style="font-size:13px;color:#666666">
              <el-row style="margin-bottom:5px;font-size:16px;font-weight:700">
                <el-col style="text-overflow: ellipsis;
                      white-space: nowrap;
                      overflow: hidden;">
                  {{p.aio_project_name||p.name}}
                </el-col>
              </el-row>
              <el-row style="margin-bottom:5px">
                <el-col :span="12">项目城市</el-col>
                <el-col :span="12">{{p.pcity||p.city||'--'}}</el-col>
              </el-row>
              <el-row style="margin-bottom:5px">
                <el-col :span="12">项目状态</el-col>
                <el-col :span="12" style="color:#50b7ed" v-if="p.online&&p.eonline">在线</el-col>
                <el-col :span="12" style="color:#c42d2d" v-else>离线</el-col>
              </el-row>
              <el-row style="margin-bottom:5px">
                <el-col :span="12">系统状态</el-col>
                <el-col :span="12" style="color:#50b7ed" v-show="p.power==1">开机</el-col>
                <el-col :span="12" style="color:#c42d2d" v-show="p.power==0">关机</el-col>
              </el-row>
              <el-row>
                <el-col :span="12">模式设置</el-col>
                <el-col :span="12">{{getDpText(p)}}</el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
         <el-row v-show="filterProjectList.filter(p=>{return !!!p.dealerid}).length==0" style="width:80%;margin:auto;font-size:20px; margin-top:100px;height:100px;line-height:25px;color:#ffffff">
        暂无相关项目
      </el-row>
  </el-collapse-item>
  <el-collapse-item style="background: inherit;" v-for="item in  dealerList.filter(d=>{return d.dealerid})" :title="item.dealername+'，项目总数：'+filterProjectList.filter(p=>{return p.dealerid==item.dealerid}).length" :name="item.dealerid"  :key="item.dealerid">
   <el-col v-for="p in filterProjectList.filter(p=>{return p.dealerid==item.dealerid})" :key="p.innerid" @click.native="select(p)" style="margin-left:20px; width: 305px;cursor:pointer;border: 1px solid #aaaaaa;color:#666666;border-radius: 20px;font-size:16px; background:#FFFFFF; margin-top:20px; padding: 10px 0;">
          <el-row></el-row>
          <el-row style="margin-top:10px;text-align:left;min-height:124px">
            <el-col :span="11">
              <div class="pic" :style="{'background-image':'url(http://resource.mibee.cn/resource/'+(p.saaspic||'dba06208-8bcd-4bfa-9478-18ebcda63264')+')'}" style="width: 100px;height: 100px;background-image: ;background-size: 100% 100%;border-radius: 20px;margin-left: 20px;margin-top: 9px;">
              </div>
            </el-col>
            <el-col :span="13" style="font-size:13px;color:#666666">
              <el-row style="margin-bottom:5px;font-size:16px;font-weight:700">
                <el-col style="text-overflow: ellipsis;
                      white-space: nowrap;
                      overflow: hidden;">
                  {{p.aio_project_name||p.name}}
                </el-col>
              </el-row>
              <el-row style="margin-bottom:5px">
                <el-col :span="12">项目城市</el-col>
                <el-col :span="12">{{p.pcity||p.city||'--'}}</el-col>
              </el-row>
              <el-row style="margin-bottom:5px">
                <el-col :span="12">项目状态</el-col>
                <el-col :span="12" style="color:#50b7ed" v-if="p.online&&p.eonline">在线</el-col>
                <el-col :span="12" style="color:#c42d2d" v-else>离线</el-col>
              </el-row>
              <el-row style="margin-bottom:5px">
                <el-col :span="12">系统状态</el-col>
                <el-col :span="12" style="color:#50b7ed" v-show="p.power==1">开机</el-col>
                <el-col :span="12" style="color:#c42d2d" v-show="p.power==0">关机</el-col>
              </el-row>
              <el-row>
                <el-col :span="12">模式设置</el-col>
                <el-col :span="12">{{getDpText(p)}}</el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
          <el-row v-show="filterProjectList.filter(p=>{return p.dealerid==item.dealerid}).length==0" style="width:80%;margin:auto;font-size:20px; margin-top:100px;height:100px;line-height:25px;color:#ffffff">
        暂无相关项目
      </el-row>
  </el-collapse-item>
</el-collapse>
<el-row v-else> 
         <el-col  v-for="p in filterProjectList" :key="p.innerid" @click.native="select(p)" style="margin-left:20px; width: 305px;cursor:pointer;border: 1px solid #aaaaaa;color:#666666;border-radius: 20px;font-size:16px; background:#FFFFFF; margin-top:20px; padding: 10px 0;">
          <el-row></el-row>
          <el-row style="margin-top:10px;text-align:left;min-height:124px">
            <el-col :span="11" style="text-align:center">
              <div class="pic" :style="{'background-image':'url(http://resource.mibee.cn/resource/'+(p.saaspic||'dba06208-8bcd-4bfa-9478-18ebcda63264')+')'}" style="width: 100px;height: 100px;background-image: ;background-size: 100% 100%;border-radius: 20px;margin-left: 20px;margin-top: 9px;margin-bottom:5px;">
              </div>
              <span style="font-size:12px;color:#999999;">{{p.protocolid===227?'AIO':'CCH'}}系统</span><img v-if="p['4gstatus']" style="margin-left:10px;height:12px;width:12px" :src='"../../static/images/icon/4g-"+(JSON.parse(p["4gstatus"]).rssiLevel||0)+".png"'/>
            </el-col>
            <el-col :span="13" style="font-size:13px;color:#666666">
              <el-row style="margin-bottom:5px;font-size:16px;font-weight:700">
                <el-col style="text-overflow: ellipsis;
                      white-space: nowrap;
                      overflow: hidden;">
                  {{p.aio_project_name||p.name}}
                </el-col>
              </el-row>
              <el-row style="margin-bottom:5px">
                <el-col :span="12">项目城市</el-col>
                <el-col :span="12">{{p.pcity||p.city||'--'}}</el-col>
              </el-row>
              <el-row style="margin-bottom:5px">
                <el-col :span="12">项目状态</el-col>
                <el-col :span="12" style="color:#50b7ed" v-if="p.online&&p.eonline">在线</el-col>
                <el-col :span="12" style="color:#c42d2d" v-else>离线</el-col>
              </el-row>
              <el-row style="margin-bottom:5px">
                <el-col :span="12">系统状态</el-col>
                <el-col :span="12" style="color:#50b7ed" v-show="p.power==1">开机</el-col>
                <el-col :span="12" style="color:#c42d2d" v-show="p.power==0">关机</el-col>
              </el-row>
              <el-row>
                <el-col :span="12">模式设置</el-col>
                <el-col :span="12">{{getDpText(p)}}</el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col></el-row>
         <el-row v-show="filterProjectList.length==0" style="width:80%;margin:auto;font-size:20px; margin-top:100px;height:100px;line-height:25px;color:#ffffff">
        暂无相关项目
      </el-row>
      <el-divider content-position="left">经典案例</el-divider>
      <el-col @click.native="$router.push({ name: 'School' })" style="margin-left:20px; width: 305px;cursor:pointer;border: 1px solid #aaaaaa;color:#666666;border-radius: 20px;font-size:16px; background:#FFFFFF; margin-top:20px; padding: 10px 0;">
          <el-row></el-row>
          <el-row style="margin-top:10px;text-align:left;min-height:124px">
            <el-col :span="11" style="text-align:center">
              <div class="pic"  style="width: 100px;height: 100px;background-image:url('http://resource.mibee.cn/resource/dba06208-8bcd-4bfa-9478-18ebcda63264') ;background-size: 100% 100%;border-radius: 20px;margin-left: 20px;margin-top: 9px;margin-bottom:5px;">
              </div>
              <span style="font-size:12px;color:#999999;"></span>
            </el-col>
            <el-col :span="13" style="font-size:13px;color:#666666">
              <el-row style="margin-bottom:5px;font-size:16px;font-weight:700">
                <el-col style="text-overflow: ellipsis;
                      white-space: nowrap;
                      overflow: hidden;">
                 曼瑞德候鸟学校
                </el-col>
              </el-row>
              <el-row style="margin-bottom:5px">
                <el-col :span="12">项目城市</el-col>
                <el-col :span="12">温州</el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      <el-col v-for="p in demoList" :key="p.innerid" @click.native="select(p)" style="margin-left:20px; width: 305px;cursor:pointer;border: 1px solid #aaaaaa;color:#666666;border-radius: 20px;font-size:16px; background:#FFFFFF; margin-top:20px; padding: 10px 0;">
          <el-row></el-row>
          <el-row style="margin-top:10px;text-align:left;min-height:124px">
            <el-col :span="11" style="text-align:center">
              <div class="pic" :style="{'background-image':'url(http://resource.mibee.cn/resource/'+(p.saaspic||'dba06208-8bcd-4bfa-9478-18ebcda63264')+')'}" style="width: 100px;height: 100px;background-image: ;background-size: 100% 100%;border-radius: 20px;margin-left: 20px;margin-top: 9px;margin-bottom:5px;">
              </div>
              <span style="font-size:12px;color:#999999;">{{p.protocolid===227?'AIO':'CCH'}}系统</span><img v-if="p['4gstatus']" style="margin-left:10px;height:12px;width:12px" :src='"../../static/images/icon/4g-"+(JSON.parse(p["4gstatus"]).rssiLevel||0)+".png"'/>
            </el-col>
            <el-col :span="13" style="font-size:13px;color:#666666">
              <el-row style="margin-bottom:5px;font-size:16px;font-weight:700">
                <el-col style="text-overflow: ellipsis;
                      white-space: nowrap;
                      overflow: hidden;">
                  {{p.aio_project_name||p.name}}
                </el-col>
              </el-row>
              <el-row style="margin-bottom:5px">
                <el-col :span="12">项目城市</el-col>
                <el-col :span="12">{{p.pcity||p.city||'--'}}</el-col>
              </el-row>
              <el-row style="margin-bottom:5px">
                <el-col :span="12">项目状态</el-col>
                <el-col :span="12" style="color:#50b7ed" v-if="p.online&&p.eonline">在线</el-col>
                <el-col :span="12" style="color:#c42d2d" v-else>离线</el-col>
              </el-row>
              <el-row style="margin-bottom:5px">
                <el-col :span="12">系统状态</el-col>
                <el-col :span="12" style="color:#50b7ed" v-show="p.power==1">开机</el-col>
                <el-col :span="12" style="color:#c42d2d" v-show="p.power==0">关机</el-col>
              </el-row>
              <el-row>
                <el-col :span="12">模式设置</el-col>
                <el-col :span="12">{{getDpText(p)}}</el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-col>

    </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Choose',
  data () {
    return {
      filterProjectList: [],
      customer: {},
      projectname: '',
      city:"",
      citys:[],
      online:1,
      activeNames: '',
      dealerList: [],
      projectlist: [],
      demoList:[],
      loading: true
    }
  },
  mounted: function () {
    var customer = window.localStorage.getItem('customer')
    customer = JSON.parse(customer)
    this.customer = customer
    if (customer.dealerid) {
      Vue.axios.post('/aio/dealer/project/device/list', {protocolid: [227, 150], showDP: false, dealerid: customer.dealerid}).then((res) => {
        if (res.data.errcode == 0) {
          if (res.data.msgbody.length == 0) {
            this.loading = false
            this.$message({
              message: '您尚未绑定任何AIO项目',
              type: 'warning'
            })
          } else {
            this.projectlist = res.data.msgbody.filter((item, index) => {
              return res.data.msgbody.findIndex(item1 => item1.projectid == item.projectid && item1.protocolid == item.protocolid) == index
            })
             this.projectlist.sort(function (a, b) {
            if((a.online&&a.eonline)==(b.online&&b.eonline)){
              return a.aio_project_name.localeCompare(b.aio_project_name, 'zh-Hans-CN', { sensitivity: 'accent' })
            }else{
              return (b.online&&b.eonline)-(a.online&&a.eonline)
            } 
            
          })
          this.citys=Array.from(new Set(this.projectlist.map(p=>{return p.pcity||p.city }).filter(d=>{return d})))
          this.citys.sort(function(a,b){
               return a.localeCompare(b, 'zh-Hans-CN', { sensitivity: 'accent' })
          })

            this.dealerList = res.data.msgbody.filter((item, index) => {
              return res.data.msgbody.findIndex(item1 => item1.dealerid == item.dealerid) == index
            })
            this.filterProjectList = this.projectlist
            this.loading = false
            this.filterProject()
          }
        } else {
          this.loading = false
          this.$message({
            showClose: true,
            message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
            type: 'error'
          })
        }
      })
      Vue.axios.post('/aio/project/demo/list', {}).then((res) => {
      if (res.data.errcode == 0) {
          this.demoList = res.data.msgbody.filter((item, index) => {
            return res.data.msgbody.findIndex(item1 => item1.projectid == item.projectid && item1.protocolid == item.protocolid) == index
          })
          this.demoList.sort(function (a, b) {
            if((a.online&&a.eonline)==(b.online&&b.eonline)){
              return a.aio_project_name.localeCompare(b.aio_project_name, 'zh-Hans-CN', { sensitivity: 'accent' })
            }else{
              return (b.online&&b.eonline)-(a.online&&a.eonline)
            } 
          })
      } else {
        this.loading = false
        this.$message({
          showClose: true,
          message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
          type: 'error'
        })
      }
    })
      return
    }

    Vue.axios.post('/project/device/query', {protocolid: [227, 150], showDP: true}).then((res) => {
      if (res.data.errcode == 0) {
        if (res.data.msgbody.length == 0) {
          this.loading = false
          this.$message({
            message: '您尚未绑定任何AIO项目',
            type: 'warning'
          })
        } else {
          this.projectlist = res.data.msgbody.filter((item, index) => {
            return res.data.msgbody.findIndex(item1 => item1.projectid == item.projectid && item1.protocolid == item.protocolid) == index
          })
          this.projectlist.sort(function (a, b) {
            if((a.online&&a.eonline)==(b.online&&b.eonline)){
              return a.aio_project_name.localeCompare(b.aio_project_name, 'zh-Hans-CN', { sensitivity: 'accent' })
            }else{
              return (b.online&&b.eonline)-(a.online&&a.eonline)
            } 
            
          })
          this.filterProjectList = this.projectlist
          this.loading = false
          this.filterProject()
        }
      } else {
        this.loading = false
        this.$message({
          showClose: true,
          message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
          type: 'error'
        })
      }
    })
    Vue.axios.post('/aio/project/demo/list', {}).then((res) => {
      if (res.data.errcode == 0) {
          this.demoList = res.data.msgbody.filter((item, index) => {
            return res.data.msgbody.findIndex(item1 => item1.projectid == item.projectid && item1.protocolid == item.protocolid) == index
          })
          this.demoList.sort(function (a, b) {
            if((a.online&&a.eonline)==(b.online&&b.eonline)){
              return a.aio_project_name.localeCompare(b.aio_project_name, 'zh-Hans-CN', { sensitivity: 'accent' })
            }else{
              return (b.online&&b.eonline)-(a.online&&a.eonline)
            } 
          })
      } else {
        this.loading = false
        this.$message({
          showClose: true,
          message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
          type: 'error'
        })
      }
    })
    console.log(this.projectlist.length)
  },
  methods: {
    back () {
      this.$router.back()
    },
    select (project) {
      project.innerid = project.projectid
      if (project.aiodp) {
        project.aiodp = JSON.parse(project.aiodp)
      }
      window.localStorage.setItem('project', JSON.stringify(project))
      this.$router.push({ name: 'Device' })
    },
    daping () {
      this.$router.push({ name: 'Pandect' })
    },
    getDpText: function (device) {
    const options227=[{value: 1, text: "全联供冷"},{value: 2, text: "全联供暖"},{value: 3, text: "新风除湿"},{value: 4, text: "热湿新风"}]
    const options150=[{value: 1, text: "制冷"},{value: 2, text: "制热"},{value: 3, text: "新风"},{value: 4, text: "除湿"},{value: 25, text: "全联供冷"},{value: 26, text: "全联供热"}]
      if (device) {
        let options
        if(device.protocolid==227){
          options=options227
        }else{
          options=options150
        }
          let t = options.filter((o) => {
            return o.value == device.mode
          })
          if (t && t.length > 0) {
            return t[0].text
          } else {
            return '--'
          }
        
      } else {
        return '--'
      }
    },
    filterProject: function () {
       this.filterProjectList = this.projectlist
      if (this.projectname) {
        this.filterProjectList = this.filterProjectList.filter((d) => {
          return d.name.indexOf(this.projectname) >= 0 || d.aio_project_name.indexOf(this.projectname) >= 0
        })
      }
      if(this.online===1||this.online===0){
         this.filterProjectList = this.filterProjectList.filter((d) => {
          return (d.online&&d.eonline)===this.online
        })
      }
      if(this.city){
         this.filterProjectList = this.filterProjectList.filter((d) => {
          return (d.pcity||d.city)===this.city
        })
      }
    }
  }
}
</script>

<style>
.el-collapse-item__wrap{
  background: inherit !important;
  padding-bottom: 20px;
  border-bottom: 1px solid #999999 !important
}

.el-collapse-item__header{
  background: inherit !important;
  color:#fff !important;
  border-bottom: 1px solid #999999 !important
}

.el-divider__text{
color: #ffffff !important;
background-color:rgb(4, 69, 120) !important;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background-color: #1263bf;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #1263bf;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #eeeeee;
}
</style>



// WEBPACK FOOTER //
// src/components/Choose.vue